export default __webpack_public_path__ + "static/media/pricing3.d6724596.webp";